import React, {useState} from "react";

import "./FactoryResetButton.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import {sleep} from "../../../lib/utils";
import {faBroom, faRotate} from "@fortawesome/free-solid-svg-icons";

function FactoryResetButton({bond}) {
    const [resetStarted, setResetStarted] = useState(false);
    const [resetLabel, setResetLabel] = useState(`Factory Reset`);
    const [showModal, setShowModal] = useState(false);
    const [confirmText, setConfirmText] = useState("");

    const expectedText = `reset ${bond.id}`;
    const isConfirmValid = confirmText.toLowerCase() === expectedText.toLowerCase();

    function handleShowModal() {
        setConfirmText("");
        setShowModal(true);
    }

    function handleCloseModal() {
        setShowModal(false);
        setConfirmText("");
    }

    async function startReset() {
        handleCloseModal();
        setResetLabel("Resetting...")
        setResetStarted(true)
        const uptime = (await bond.get("/sys/version/"))["uptime_s"] + 2;
        await sleep(100);
        await bond.put('/sys/reset', {"type": "factory_keep_token_network"})
        let timeout = 15000;
        while (timeout > 0) {
            await sleep(2000);
            timeout -= 2000;
            try {
                setResetLabel("Rebooting...")
                let newUptime = (await bond.get("/sys/version/"))["uptime_s"];
                if (newUptime && newUptime < uptime) break;
            } catch {
                await sleep(1000);
            }
        }
        setResetLabel("Factory Reset")
        setResetStarted(false);
    }

    return (
        <>
            <Accordion className="factory-reset-accordion">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <FontAwesomeIcon icon={faBroom} className="me-2" />
                        Factory Reset
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="d-grid gap-2">
                            <Button size={"lg"} className={"factoryResetButton"} disabled={resetStarted} variant={"outline-danger"}
                                    onClick={handleShowModal}>
                                <FontAwesomeIcon icon={resetStarted ? faRotate : faBroom} size="xl"
                                                 className={`me-4 ${resetStarted ? "fa-spin" : ""}`}/>
                                {resetLabel}
                            </Button>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>⚠️ Factory Reset ⚠️</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger fw-bold">
                        Are you sure you want to factory reset bond {bond.id}?
                    </p>
                    <p>All information will be deleted. This action cannot be undone.</p>
                    <Form.Group className="mt-3">
                        <Form.Label>
                            To confirm, type: <code>reset {bond.id}</code>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={confirmText}
                            onChange={(e) => setConfirmText(e.target.value)}
                            placeholder={`reset ${bond.id}`}
                            autoFocus
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={startReset} disabled={!isConfirmValid}>
                        ⚠️ Factory Reset ⚠️
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FactoryResetButton;


